const dictOperationReason = {
  USER_REQUESTED: 'USER_REQUESTED',
  ACCOUNT_CLOSURE: 'ACCOUNT_CLOSURE',
  BRANCH_TRANSFER: 'BRANCH_TRANSFER',
  ENTRY_INACTIVITY: 'ENTRY_INACTIVITY',
  RECONCILIATION: 'RECONCILIATION',
  FRAUD: 'FRAUD',
  DEFAULT_OPERATION: 'DEFAULT_OPERATION'
};

module.exports = dictOperationReason;
